import { JWT_LS } from '../starter/constants'


export const getTokenFromLocalStorage = () => {
  return localStorage.getItem(JWT_LS)
}

// export const getTokenFromStore = () => {
//   const { token } = {...store.getState().auth}
//   const res = token
//   return res
// }
